<div class="kpi-card">
  <div class="kpi-card__body">
    <div class="kpi-card__body__title-row">
      <h5 class="kpi-card__body__title-row__title">{{ kpiData().title }}</h5>
      <p-button icon="pi pi-external-link" (onClick)="onGoToDetailsClick()" [rounded]="true" variant="text" />
    </div>

    <div class="kpi-card__body__value-row">
      <div
        class="kpi-card__body__value-row__value"
        [pTooltip]="'pages.transport.tracking-overview.widgets.key-indicators.kpi-cards.descriptions.value' | translate"
        tooltipPosition="top"
      >
        {{ kpiData().value | localizedNumber }}
      </div>
      @if (valueComparisonPercentage()) {
        <div
          class="kpi-card__body__value-row__value-comparison"
          [pTooltip]="'pages.transport.tracking-overview.widgets.key-indicators.kpi-cards.descriptions.comparison' | translate"
          tooltipPosition="top"
        >
          ({{ valueComparisonPercentage() | localizedNumber: '1.0-0' }}%)
        </div>
      }
    </div>

    <span
      class="kpi-card__body__change"
      [class.kpi-card__body__change--positive]="isPositiveDirection()"
      [class.kpi-card__body__change--negative]="isNegativeDirection()"
      [class.kpi-card__body__change--increase]="isValueChangeIncrease()"
      [pTooltip]="'pages.transport.tracking-overview.widgets.key-indicators.kpi-cards.descriptions.change' | translate"
      tooltipPosition="top"
    >
      @if (valueChangePercentage()) {
        {{ valueChangePercentage() | localizedNumber: '1.0-0' }}%
      }
      @if (!valueChangePercentage()) {
        +-0%
      }
    </span>
  </div>

  <div class="kpi-card__chart">
    <p-chart [responsive]="true" width="100%" height="50px" type="line" [data]="chartData()" [options]="chartOptions"></p-chart>
  </div>
</div>
